var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormElementRadioItem.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormElementRadioItem.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["id", "name", "paramValue", "radioValue", "caption"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("id", Object.prototype.hasOwnProperty.call(kwargs, "id") ? kwargs["id"] : "");frame.set("name", Object.prototype.hasOwnProperty.call(kwargs, "name") ? kwargs["name"] : "");frame.set("paramValue", Object.prototype.hasOwnProperty.call(kwargs, "paramValue") ? kwargs["paramValue"] : 0);frame.set("radioValue", Object.prototype.hasOwnProperty.call(kwargs, "radioValue") ? kwargs["radioValue"] : 0);frame.set("caption", Object.prototype.hasOwnProperty.call(kwargs, "caption") ? kwargs["caption"] : "");var t_5 = "";t_5 += "\n    <div class=\"SubmissionFormElement-radioWrapper\">\n        <input type=\"radio\" id=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
t_5 += "\" name=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "name"), env.opts.autoescape);
t_5 += "\" class=\"SubmissionFormElement-radio\"\n                ";
if(runtime.contextOrFrameLookup(context, frame, "paramValue") == runtime.contextOrFrameLookup(context, frame, "radioValue")) {
t_5 += " checked";
;
}
t_5 += " value=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "radioValue"), env.opts.autoescape);
t_5 += "\">\n        <label class=\"SubmissionFormElement-radioLabel\" for=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
t_5 += "\">\n            <div class=\"SubmissionFormElement-radioLabelIcon\"></div>\n            <div class=\"SubmissionFormElement-radioLabelName\">";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "caption"), env.opts.autoescape);
t_5 += "</div>\n        </label>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("SubmissionFormElementRadioItem");
context.setVariable("SubmissionFormElementRadioItem", macro_t_4);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormElementRadioItem.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormElementRadioItem.jinja
// module id = 54
// module chunks = 0